import styles from './license-usage.module.scss';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import LicenseUsageGrid from '../license-usage-grid/license-usage-grid';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface LicenseUsageProps { }

export function LicenseUsage(props: LicenseUsageProps) {
  const { t } = useTranslation();

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.licenseExploitation")} />
            <LicenseUsageGrid />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default LicenseUsage;